import { render, staticRenderFns } from "./WebhostingPackagePrices.vue?vue&type=template&id=00f324b7&scoped=true&"
import script from "./WebhostingPackagePrices.vue?vue&type=script&lang=js&"
export * from "./WebhostingPackagePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f324b7",
  null
  
)

export default component.exports